var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-tool-bar"},[_c('div',{staticClass:"list-title"},[_c('span',[_vm._v(_vm._s(_vm.routeTitle))]),_c('div',{staticClass:"title-append"},[_vm._t("title-append")],2)]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }